export default function Footer() {
  return (
    <footer className="bg-[#2C5F4F] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Tagline */}
          <div>
            <img
              src="https://static.readdy.ai/image/dd95bba129a4e648d9c1ab0ceae0e9b1/8b930cfb7da67169cd8afa37527c0dcf.jpeg"
              alt="Duendecillos Let's Play"
              className="h-16 w-auto mb-4 bg-white rounded-lg p-2"
            />
            <p className="text-lg font-medium text-white/90">Cuidamos a quienes más quieres</p>
            
            {/* Centro Autorizado */}
            <div className="flex items-center gap-3 mt-4">
              <img
                src="https://static.readdy.ai/image/dd95bba129a4e648d9c1ab0ceae0e9b1/43b2689c9af6658f044c8e8869073500.webp"
                alt="Comunidad de Madrid"
                className="h-12 w-auto bg-white rounded p-1"
              />
              <span className="text-white/90 font-semibold text-sm">Centro Autorizado</span>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contacto</h3>
            <div className="space-y-2 text-white/80">
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                Calle Ravena 3. 28032. Madrid.
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                673 140 684 / 918 331 997
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                info@duendecillosletsplay.es
              </p>
              <a 
                href="https://www.instagram.com/duendecillosletsplay/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line mr-2"></i>
                @duendecillosletsplay
              </a>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-lg font-bold mb-4">Horarios</h3>
            <div className="space-y-2 text-white/80">
              <p>Lunes a Viernes</p>
              <p className="font-semibold text-white">09:00 - 16:00</p>
              <p className="text-sm">Horario ampliado disponible:</p>
              <p className="text-sm">07:30 - 18:00</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/70 text-sm mb-4 md:mb-0">
            © 2025 Duendecillos Let's Play. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com/duendecillosletsplay/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#E1306C] hover:to-[#F77737] rounded-full transition-all cursor-pointer"
            >
              <i className="ri-instagram-line text-lg text-white"></i>
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-white text-sm transition-colors whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
